/* eslint-disable */
import { StyleSheet ,Platform} from 'react-native'

import {ifIPhoneX} from '../../Lib/utils'
import { Fonts, ApplicationStyles} from   '../../Themes'
export default StyleSheet.create({
  
  navbar : {
    backgroundColor: Fonts.style.color.navbar
  },
 
  statusBar: {
    ...Platform.select({
      ios: ifIPhoneX({ height: 31 }, { height: 20 }), // 44
      android: { height: 0 },
    }),
  },

  content: {
    height: 44,
    justifyContent: 'center',
  },

  leftButtons: {
    position: 'absolute',
  },

  rightButtons: {
    position: 'absolute',
    right: 0,
  },

  titleWhite: {
    alignSelf: 'center',
    backgroundColor: 'transparent',
    color: Fonts.style.color.white,
    fontFamily:Fonts.style.font.light,
    fontSize: 17,
    paddingBottom: 2,
  },
  titleBlack: {
    alignSelf: 'center',
    backgroundColor: 'transparent',
    color: Fonts.style.color.black,
    fontFamily:Fonts.style.font.light,
    fontSize: 17,
    paddingBottom: 2,
  },
  logo: {
    alignSelf: 'center',
  },

  button: {
    padding: 14,
    backgroundColor: 'transparent',
  },

  buttonTitle: {
    color: Fonts.style.color.white,
    fontFamily: Fonts.style.font.light,
    fontSize: 14,
  },
})
